/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Trendmover_MetricsInputs */

const en_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile app delivery`)
};

const ar_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسليم تطبيقات الهاتف`)
};

const bn_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মোবাইল অ্যাপ ডেলিভারি`)
};

const de_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereitstellung mobiler Apps`)
};

const es_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega de aplicaciones móviles`)
};

const fr_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison d'applications mobiles`)
};

const pt_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega de aplicativos móveis`)
};

const zh_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移动应用程序交付`)
};

const tr_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil uygulama dağıtımı`)
};

const ru_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка мобильного приложения`)
};

const pl_experience_trendmover_metrics = /** @type {(inputs: Experience_Trendmover_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostarczanie aplikacji mobilnych`)
};

/**
* | output |
* | --- |
* | "Mobile app delivery" |
*
* @param {Experience_Trendmover_MetricsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_trendmover_metrics = /** @type {((inputs?: Experience_Trendmover_MetricsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Trendmover_MetricsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_trendmover_metrics(inputs)
	if (locale === "bn") return bn_experience_trendmover_metrics(inputs)
	if (locale === "de") return de_experience_trendmover_metrics(inputs)
	if (locale === "es") return es_experience_trendmover_metrics(inputs)
	if (locale === "fr") return fr_experience_trendmover_metrics(inputs)
	if (locale === "pt") return pt_experience_trendmover_metrics(inputs)
	if (locale === "zh") return zh_experience_trendmover_metrics(inputs)
	if (locale === "tr") return tr_experience_trendmover_metrics(inputs)
	if (locale === "ru") return ru_experience_trendmover_metrics(inputs)
	if (locale === "pl") return pl_experience_trendmover_metrics(inputs)
	return en_experience_trendmover_metrics(inputs)
});